import React, {Component} from 'react';
import {ContactForm} from './contact-form'
import {Paragraph } from '../Paragraph'

import './contact.css';

let methodsStyle = {
  fontSize: '14px',
  lineHeight: 1.5,
  margin: 0,
  padding: 0,
  textDecoration: 'none'
};

class Contact extends Component {


  renderMethod(method) {
    if (!method.isLink) {
      return (
        <p
          style={methodsStyle}
          className="paragraph-text"> {method.text}</p>
      );
    }

    return (
      <a
        href ={"mailto:" + method.text}
        style={methodsStyle}
        className="email-link"
        target="_blank">{method.text}</a>
    );
  }
  render() {
    let data = this.props.data;

    let methods = data.methods.map(
      (method, index) =>
        <div key={index} style={{marginBottom: (index + 1) % 3 == 0 ? 15 : 0}}>
          {this.renderMethod(method)}
        </div>
      );

    return (
    <div className="clearfix">
      <div className="contact-info">

        <div className="contact-title">
          {data.title}
        </div>
        <br></br>
        {methods}
        <div className="contact-info-item">
          {data.instruction}
        </div>

      </div>

      <div className="contact-form-container">
        <ContactForm data = {data.form}></ContactForm>
      </div>

    </div>
    );
  }
}

export default {Contact}



// WEBPACK FOOTER //
// ./src/components/Contact/index.js